import { z } from 'my-zod'
import { outfitterUsersModel } from './outfitter-users-model'

export const outfitterUserSystemView = outfitterUsersModel
export type outfitterUserSystemView = z.infer<typeof outfitterUserSystemView>

export const extendedOutfitterUserSystemView = outfitterUsersModel.augment({
  businessName: z.string()
})
export type extendedOutfitterUserSystemView = z.infer<typeof extendedOutfitterUserSystemView>
